import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataResponseApi(params) {
	return client.get("api/response-api/data", {
		params: params,
	});
}

function getDataResponseApiEcommerce(params) {
	return client.get("api/response-api/data-ecommerce", {
		params: params,
	});
}

export default {
	getDataResponseApi,
	getDataResponseApiEcommerce,
};